export function Save() {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.5 9H5.5V5H15.5V9ZM12.5 19C11.7044 19 10.9413 18.6839 10.3787 18.1213C9.81607 17.5587 9.5 16.7956 9.5 16C9.5 15.2044 9.81607 14.4413 10.3787 13.8787C10.9413 13.3161 11.7044 13 12.5 13C13.2956 13 14.0587 13.3161 14.6213 13.8787C15.1839 14.4413 15.5 15.2044 15.5 16C15.5 16.7956 15.1839 17.5587 14.6213 18.1213C14.0587 18.6839 13.2956 19 12.5 19ZM17.5 3H5.5C4.39 3 3.5 3.9 3.5 5V19C3.5 19.5304 3.71071 20.0391 4.08579 20.4142C4.46086 20.7893 4.96957 21 5.5 21H19.5C20.0304 21 20.5391 20.7893 20.9142 20.4142C21.2893 20.0391 21.5 19.5304 21.5 19V7L17.5 3Z'
        fill='currentColor'
      />
    </svg>
  );
}
